import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { Property } from '../../types/user';
import { MonthlyStats } from '../../types/property';
import { formatCurrency } from '../format';

export const generatePropertyReport = (property: Property, monthlyStats: MonthlyStats[]): jsPDF => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;

  // Calcular totales y promedios anuales
  const yearlyTotals = monthlyStats.reduce((acc, stat) => ({
    revenue: acc.revenue + stat.revenue,
    cleaningCosts: acc.cleaningCosts + stat.cleaningCosts,
    inmohostCosts: acc.inmohostCosts + stat.inmohostCosts,
    profit: acc.profit + stat.profit,
    occupancyRate: acc.occupancyRate + stat.occupancyRate,
    reservations: acc.reservations + stat.reservations,
  }), {
    revenue: 0,
    cleaningCosts: 0,
    inmohostCosts: 0,
    profit: 0,
    occupancyRate: 0,
    reservations: 0,
  });

  const monthCount = monthlyStats.length || 1;
  const averageOccupancy = Math.round(yearlyTotals.occupancyRate / monthCount);

  // Configurar estilos
  doc.setFont('helvetica');
  doc.setFontSize(24);
  doc.setTextColor(0, 0, 0);

  // Añadir encabezado
  doc.text(property.name, 20, 30);
  doc.setFontSize(14);
  doc.text(property.location, 20, 40);

  // Añadir resumen anual
  doc.setFontSize(16);
  doc.text('Resumen Anual', 20, 60);

  const summaryData = [
    ['Indicadores Económicos', ''],
    ['Facturación Total', formatCurrency(yearlyTotals.revenue)],
    ['Gastos Limpieza', formatCurrency(yearlyTotals.cleaningCosts)],
    ['Gastos INMOHOST', formatCurrency(yearlyTotals.inmohostCosts)],
    ['Beneficio Total', formatCurrency(yearlyTotals.profit)],
    ['', ''],
    ['Indicadores de Ocupación', ''],
    ['Ocupación Media', `${averageOccupancy}%`],
    ['Total Reservas', yearlyTotals.reservations.toString()],
  ];

  (doc as any).autoTable({
    startY: 70,
    head: [['Concepto', 'Valor']],
    body: summaryData,
    theme: 'grid',
    headStyles: { fillColor: [239, 68, 68] },
    styles: { fontSize: 12 },
    columnStyles: {
      0: { cellWidth: 100 },
      1: { cellWidth: 60 }
    }
  });

  // Añadir datos mensuales
  doc.addPage();
  doc.setFontSize(16);
  doc.text('Datos Mensuales', 20, 20);

  const monthlyData = monthlyStats.map(stat => [
    format(new Date(stat.year, stat.month - 1), 'MMMM yyyy', { locale: es }),
    formatCurrency(stat.revenue),
    formatCurrency(stat.cleaningCosts),
    formatCurrency(stat.inmohostCosts),
    formatCurrency(stat.profit),
    `${stat.occupancyRate}%`,
    stat.reservations
  ]);

  (doc as any).autoTable({
    startY: 30,
    head: [['Mes', 'Facturación', 'G.Limpieza', 'G.INMOHOST', 'Beneficio', 'Ocupación', 'Reservas']],
    body: monthlyData,
    theme: 'grid',
    headStyles: { fillColor: [239, 68, 68] },
    styles: { fontSize: 10 }
  });

  // Añadir pie de página
  const footer = `Informe generado el ${format(new Date(), 'dd/MM/yyyy HH:mm', { locale: es })}`;
  doc.setFontSize(10);
  doc.setTextColor(128);
  doc.text(footer, pageWidth / 2, doc.internal.pageSize.height - 10, { align: 'center' });

  return doc;
};